// STYLES
import * as Style from "./NewcomeUsersStyle";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC

// ASSETS

// REDUX

// COMPONENTS
import NewcomeUser from "components/NewcomeUser/NewcomeUser";

const NewcomeUsers = ({ recentRegisteredUsersStatisticsData }) => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const { t } = useTranslation();

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS

  return (
    <Style.NewcomeUsersContainer>
      <Style.NewcomeUsersContainerTitle>
        {t("page.dashboard.newComeUsers.title")}
      </Style.NewcomeUsersContainerTitle>
      <Style.NewcomeUsersWrapper>
        <Style.NewcomeUsersContent>
          {recentRegisteredUsersStatisticsData?.recentRegisteredUsers?.map(
            (user, index) => (
              <NewcomeUser key={index} user={user} />
            )
          )}
        </Style.NewcomeUsersContent>
      </Style.NewcomeUsersWrapper>
    </Style.NewcomeUsersContainer>
  );
};

export default NewcomeUsers;
